import FinalidadeEmissao from "./enum/finalidadeEmissao";

export default class NaturezaOperacaoFinalidadeEmissaoModel {
    id?: number = null;
    naturezaOperacaoId: number = null;
    finalidadeEmissao: FinalidadeEmissao = null;
    finalidadeEmissaoDescricao: string = null;
}
